import React, { useState, useEffect } from 'react';
import { Row, Col, Label, Input, FormGroup, Button, Spinner, CardBody, Badge, Table, CardHeader, Collapse, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import uuid from 'react-uuid';
import { FaPlus, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import Select, { components, ValueContainerProps } from 'react-select';
import FarmAPTThanksTo from '../FarmApt/FarmAPTThanksTo';
import axios from 'axios';
import ReadMoreContentCustom from '../Utilities/Ui/ReadMoreCustom';

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const groupStyles = {
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'space-between',
    backgroundColor: '#1A959E',
    color: 'black',
    fontSize: 18,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
    marginBottom: '8px'
};

export interface GroupedOption {
    label: string;
}

const formatGroupLabel = (data: GroupedOption) => (
    <div style={groupStyles}>
        <span style={{color:"black"}}><b>{data.label}</b></span>
    </div>
);

const ItemBasedActivityRisk = ({ actionPopup, handleActivityRiskClose, activityRiskModel, activityRiskPopup, lmuId, handleActivityRiskSelect, farmAPTActionList, ItemAction }) => {
    const [editMode, setEditMode] = useState(false);
    const [disableCustomRisk, setDisableCustomRisk] = useState(false); const [selectTitle, setSelectTitle] = useState('Select'); const [disableRecommendedAction, setDisableRecommendedAction] = useState(false);
    const [activityRiskValue, setActivityRiskValue] = useState(""); const [activityRiskList, setActivityRiskList] = useState([]);
    const [luValue, setLUValue] = useState(""); const [luList, setLUList] = useState([]);
    const [itemBasedRecommendedActionOptions, setItemBasedRecommendedActionOptions] = useState([]);
    const [recommendedActionOptions, setRecommendedActionOptions] = useState([]);
    const [farmAPTOptions, setFarmAPTOptions] = useState([]);
    const [showRecommendedActionDropdown, setShowRecommendedActionDropdown] = useState(true); const [recommendedActionValue, setRecommendedActionValue] = useState("");
    const [recommendedActionList, setRecommendedActionList] = useState([]); const [showRecommendedActionText, setShowRecommendedActionText] = useState(false);
    const [recommendedActionTextValue, setRecommendedActionTextValue] = useState("");
    const [groupedOptions, setGroupedOptions] = useState([
    { label: "Mapped Item: " + actionPopup.name + " - consider these actions", options: itemBasedRecommendedActionOptions },
    { label: "Other Possible Actions", options: recommendedActionOptions },
        /*{ label: "Farm APT Actions - List thanks to DairyNZ. For more information see FarmAPT section in CCCV page", options: farmAPTOptions }*/
    ]);
    const [riskChange, setRiskChange] = useState(actionPopup.id == 0 ? true : false);
    const [selectedActivity, setSelectedActivity] = useState({});
    const handleLUInputChange = (e) => {
        setLUValue(e);
        let lus = '';
        if (Array.isArray(e)) {
            let luArr = [];
            e.forEach(risk => {
                luArr.push(risk.value);
            })
            lus = luArr.join(",");
        }
        activityRiskPopup.luId = lus;
    }
    const changeActivityRiskinput1 = (e) => {
        let selectedEnterpriseType = '';
        selectedEnterpriseType = e[0].value;
        activityRiskPopup.activityRiskId = selectedEnterpriseType;
        activityRiskPopup.activityRiskIds = e.map(x => x.value).join(",");
        setActivityRiskValue(e);
        activityRiskPopup.activityRiskText = e.map(x => x.label).join(",");
        activityRiskPopup.luId = '';
        setLUValue('');
        var luItems = [];
        for (var k = 0; k < e.length; k++) {
            activityRiskModel.luList.filter(x => x.parentId == parseInt(e[k].value)).forEach((obj, index) => {
                if (luItems.filter(x => x.value == obj.value).length == 0) {
                    luItems.push(obj);
                }
            });
        }
        setLUList(luItems);
        if (ItemAction) {
        }

        if (!editMode) {
            activityRiskPopup.recommendedActionId = 0;
            setRecommendedActionValue("");
            setRecommendedActionList([])
            setShowRecommendedActionDropdown(false);
            setShowRecommendedActionText(false);
            activityRiskPopup.recommendedActionText = "";
            activityRiskPopup.recommendedActionDescription = "";
            var farmAPTList = [];
            farmAPTActionList.forEach((obj, index) => {
                var farmAPTObj = { label: obj.name, parentId: 0, value: obj.id, type: 'FarmAPT', description: obj.meta.desc };
                farmAPTList.push(farmAPTObj);
            });
            var recommendedActionList1 = [];

            for (var k = 0; k < e.length; k++) {
                var recommendedActionCount = activityRiskModel.recommendedActionList.filter(x => x.parentId == parseInt(e[k].parentId)).length;
                if (recommendedActionCount != 0) {
                    activityRiskModel.recommendedActionList.filter(x => x.parentId == parseInt(e[k].parentId)).forEach((obj, index) => {
                        var recommendedActionObj = { label: obj.label, parentId: obj.parentId, value: obj.value, type: 'RecommendedAction', description: obj.description };
                        recommendedActionList1.push(recommendedActionObj);
                    });
                }
            }
            var otherRecommendedActionObj = { label: 'Record a specific action', parentId: 0, value: 0, type: 'Other' };
            recommendedActionList1.push(otherRecommendedActionObj);
            setRecommendedActionList(recommendedActionList1);
            setRecommendedActionOptions(recommendedActionList1);

            setFarmAPTOptions(farmAPTList);
            setGroupedOptions([
                { label: "Possible Actions", options: recommendedActionList1 },
                /*{ label: "Farm APT Actions - List thanks to DairyNZ. For more information see FarmAPT section in CCCV page", options: farmAPTList }*/
            ]);
            setShowRecommendedActionDropdown(true);
        }
    }
    const changeActivityRiskinput = (e) => {
        let selectedEnterpriseType = '';
        selectedEnterpriseType = e[0].value;
        activityRiskPopup.activityRiskId = selectedEnterpriseType;
        activityRiskPopup.activityRiskIds = e.map(x => x.value).join(",");
        setActivityRiskValue(e);
        activityRiskPopup.activityRiskText = e.map(x => x.label).join(",");

        activityRiskPopup.luId = '';
        setLUValue('');
        var luItems = [];
        for (var k = 0; k < e.length; k++) {
            activityRiskModel.luList.filter(x => x.parentId == parseInt(e[k].value)).forEach((obj, index) => {
                if (luItems.filter(x => x.value == obj.value).length == 0) {
                    luItems.push(obj);
                }
            });
        }
        setLUList(luItems);
        if (ItemAction) {
            var luList = []; var luIds = '';
            for (var k = 0; k < e.length; k++) {
                luItems.filter(x => lmuId.split(',').filter(y => parseInt(y) == x.value).length > 0 && x.parentId == parseInt(e[k].value)).map(item => {
                    if (luItems.filter(x => x.value == item.value).length == 0) {
                        luList.push(item);
                        if (luIds == '') {
                            luIds = item.value.toString();
                        }
                        else {
                            luIds = luIds + ',' + item.value.toString();
                        }
                    }
                });
            }
            setLUValue(luList);
            activityRiskPopup.luId = luIds;
        }

        if (!editMode) {
            activityRiskPopup.recommendedActionId = 0;
            setRecommendedActionValue("");
            setRecommendedActionList([])
            setShowRecommendedActionDropdown(false);
            setShowRecommendedActionText(false);
            activityRiskPopup.recommendedActionText = "";
            activityRiskPopup.recommendedActionDescription = "";
            var farmAPTList = [];
            farmAPTActionList.forEach((obj, index) => {
                var farmAPTObj = { label: obj.name, parentId: 0, value: obj.id, type: 'FarmAPT', description: obj.meta.desc };
                farmAPTList.push(farmAPTObj);
            });
            var recommendedActionList1 = [];

            for (var k = 0; k < e.length; k++) {
                var recommendedActionCount = activityRiskModel.recommendedActionList.filter(x => x.parentId == parseInt(e[k].parentId)).length;
                if (recommendedActionCount != 0) {
                    activityRiskModel.recommendedActionList.filter(x => x.parentId == parseInt(e[k].parentId)).forEach((obj, index) => {
                        var recommendedActionObj = { label: obj.label, parentId: obj.parentId, value: obj.value, type: 'RecommendedAction', description: obj.description };
                        recommendedActionList1.push(recommendedActionObj);
                    });
                }
            }
            var otherRecommendedActionObj = { label: 'Record a specific action', parentId: 0, value: 0, type: 'Other' };
            recommendedActionList1.push(otherRecommendedActionObj);
            setRecommendedActionList(recommendedActionList1);
            setRecommendedActionOptions(recommendedActionList1);

            setFarmAPTOptions(farmAPTList);
            setGroupedOptions([
                { label: "Possible Actions", options: recommendedActionList1 },
                /*{ label: "Farm APT Actions - List thanks to DairyNZ. For more information see FarmAPT section in CCCV page", options: farmAPTList }*/
            ]);
            setShowRecommendedActionDropdown(true);
        }
    }
    const handleActivityRiskInputChange = (e) => {
        if (e == null || e.length == 0) {
            activityRiskPopup.activityRiskId = 0;
            setActivityRiskValue('');
            activityRiskPopup.activityRiskText = '';
            activityRiskPopup.luId = '';
            setLUValue('');
            setLUList('');
            activityRiskPopup.recommendedActionId = 0;
            setRecommendedActionValue("");
            setRecommendedActionList([])
            setShowRecommendedActionDropdown(false);
            setShowRecommendedActionText(false);
        }
        else {
            let selectedEnterpriseType = '';
            selectedEnterpriseType = e[0].value;
            activityRiskPopup.activityRiskId = selectedEnterpriseType;
            activityRiskPopup.activityRiskIds = e.map(x => x.value).join(",");
            setActivityRiskValue(e);
            activityRiskPopup.activityRiskText = e.map(x => x.label).join(",");

            activityRiskPopup.luId = '';
            setLUValue('');
            var luItems = [];
            for (var k = 0; k < e.length; k++) {
                activityRiskModel.luList.filter(x => x.parentId == parseInt(e[k].value)).forEach((obj, index) => {
                    if (luItems.filter(x => x.value == obj.value).length == 0) {
                        luItems.push(obj);
                    }
                });
            }
            setLUList(luItems);
            if (ItemAction) {
                var luList = []; var luIds = '';
                for (var k = 0; k < e.length; k++) {
                    luItems.filter(x => lmuId.split(',').filter(y => parseInt(y) == x.value).length > 0 && x.parentId == parseInt(e[k].value)).map(item => {
                        if (luItems.filter(x => x.value == item.value).length == 0) {
                            luList.push(item);
                            if (luIds == '') {
                                luIds = item.value.toString();
                            }
                            else {
                                luIds = luIds + ',' + item.value.toString();
                            }
                        }
                    });
                }
                setLUValue(luList);
                activityRiskPopup.luId = luIds;
            }

            if (!editMode) {
                activityRiskPopup.recommendedActionId = 0;
                setRecommendedActionValue("");
                setRecommendedActionList([])
                setShowRecommendedActionDropdown(false);
                setShowRecommendedActionText(false);
                activityRiskPopup.recommendedActionText = "";
                activityRiskPopup.recommendedActionDescription = "";
                var farmAPTList = [];
                farmAPTActionList.forEach((obj, index) => {
                    var farmAPTObj = { label: obj.name, parentId: 0, value: obj.id, type: 'FarmAPT', description: obj.meta.desc };
                    farmAPTList.push(farmAPTObj);
                });
                var recommendedActionList1 = [];

                for (var k = 0; k < e.length; k++) {
                    var recommendedActionCount = activityRiskModel.recommendedActionList.filter(x => x.parentId == parseInt(e[k].parentId)).length;
                    if (recommendedActionCount != 0) {
                        activityRiskModel.recommendedActionList.filter(x => x.parentId == parseInt(e[k].parentId)).forEach((obj, index) => {
                            var recommendedActionObj = { label: obj.label, parentId: obj.parentId, value: obj.value, type: 'RecommendedAction', description: obj.description };
                            recommendedActionList1.push(recommendedActionObj);
                        });
                    }
                }
                var otherRecommendedActionObj = { label: 'Record a specific action', parentId: 0, value: 0, type: 'Other' };
                recommendedActionList1.push(otherRecommendedActionObj);
                setRecommendedActionList(recommendedActionList1);
                setRecommendedActionOptions(recommendedActionList1);
                setFarmAPTOptions(farmAPTList);
                setGroupedOptions([
                    { label: "Possible Actions", options: recommendedActionList1 },
                    /*{ label: "Farm APT Actions - List thanks to DairyNZ. For more information see FarmAPT section in CCCV page", options: farmAPTList }*/
                ]);
                setShowRecommendedActionDropdown(true);
            }
        }

    }
    const handleCustomRecommendedActionInputChange = (e) => {
        setRecommendedActionValue(e);
        activityRiskPopup.recommendedActionText = e.label;
        activityRiskPopup.recommendedActionId = e.value;
    }
    const handleRecommendedActionInputChange = (e) => {
        setRecommendedActionValue(e);
        if (e[0].type == 'FarmAPT') {
            activityRiskPopup.recommendedActionId = 0;
        }
        else {
            activityRiskPopup.recommendedActionId = e[0].value;
        }
        activityRiskPopup.recommendedActionText = e[0].label;
        activityRiskPopup.recommendedActionDescription = e[0].description;
        activityRiskPopup.recommendedActionList = e;
        setShowRecommendedActionText(false);
    }
    const handleRecommendedActionTextChange = (e) => {
        setRecommendedActionTextValue(e.target.value);
        activityRiskPopup.recommendedActionId = 0;
        activityRiskPopup.recommendedActionText = e.target.value;
    };
    const [confirmRiskChangePopup, setConfirmRiskChangePopup] = useState({ showConfirmRiskChangePopup: false, id: 0 });
    useEffect(() => {
        setActivityRiskList(activityRiskModel.activityRiskList);
        setActivityRiskValue(activityRiskModel.activityRiskList);
        activityRiskPopup.activityRiskId = activityRiskModel.activityRiskList[0].value;
        activityRiskPopup.activityRiskIds = activityRiskModel.activityRiskList.map(x => x.value).join(",");
        activityRiskPopup.activityRiskText = activityRiskModel.activityRiskList.map(x => x.label).join(",");

        setLUValue(activityRiskModel.luList);
        setLUList(activityRiskModel.luList);
        let lus = '';
        if (Array.isArray(activityRiskModel.luList)) {
            let luArr = [];
            activityRiskModel.luList.forEach(risk => {
                luArr.push(risk.value);
            })
            lus = luArr.join(",");
        }
        activityRiskPopup.luId = lus;

        var farmAPTList = [];
        farmAPTActionList.forEach((obj, index) => {
            var farmAPTObj = { label: obj.name, parentId: 0, value: obj.id, type: 'FarmAPT', description: obj.meta.desc };
            farmAPTList.push(farmAPTObj);
        });
        var recommendedActionList1 = [];
        var recommendedActionList2 = [];
        var e = activityRiskModel.activityRiskList;
        for (var k = 0; k < e.length; k++) {
            var recommendedActionCount = activityRiskModel.recommendedActionList.filter(x => x.parentId == parseInt(e[k].parentId)).length;
            if (recommendedActionCount != 0) {
                activityRiskModel.recommendedActionList.filter(x => x.parentId == parseInt(e[k].parentId)).forEach((obj, index) => {
                    var recommendedActionObj = { label: obj.label, parentId: obj.parentId, value: obj.value, type: 'RecommendedAction', description: obj.description };
                    recommendedActionList1.push(recommendedActionObj);
                });
            }
        }
        var otherRecommendedActionObj = { label: 'Record a specific action', parentId: 0, value: 0, type: 'Other' };
        recommendedActionList1.push(otherRecommendedActionObj);
        activityRiskModel.itemBasedRecommendedActionList.forEach((obj, index) => {
            var recommendedActionObj = { label: obj.label, parentId: obj.parentId, value: obj.value, type: 'RecommendedAction', description: obj.description };
            recommendedActionList2.push(recommendedActionObj);
        });
        setRecommendedActionList(recommendedActionList1);
        setRecommendedActionOptions(recommendedActionList1);
        setItemBasedRecommendedActionOptions(recommendedActionList2);
        setFarmAPTOptions(farmAPTList);
        setGroupedOptions([
            { label: "Mapped Item: " + actionPopup.name + " - consider these actions", options: recommendedActionList2 },
            { label: "Other Possible Actions", options: recommendedActionList1 },
            /*{ label: "Farm APT Actions - List thanks to DairyNZ. For more information see FarmAPT section in CCCV page", options: farmAPTList }*/
        ]);
        setShowRecommendedActionDropdown(true);

    }, []);
    const handleConfirmRiskChangePopupClose = () => {
        setConfirmRiskChangePopup({ ...confirmRiskChangePopup, showConfirmRiskChangePopup: false, id: 0 })
    }
    const handleConfirmRiskChange = async (e) => {
        e.preventDefault();
        setConfirmRiskChangePopup({ ...confirmRiskChangePopup, showConfirmRiskChangePopup: false, id: 0 })
        setRiskChange(true);
        changeActivityRiskinput(selectedActivity);
    }
    return (
        <>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Modal size="lg" style={{ maxWidth: '45vw', width: '100%' }} isOpen={activityRiskPopup.showActivityRisk}>
                <ModalHeader toggle={handleActivityRiskClose}>Activity Risk</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm="12" style={{display:"none"}}>
                            <span style={{ fontSize: "110%" }} className="badge rounded-pill badge-success">1</span><label style={{ display: "contents" }} className="outlineLabel para-light-sm ">&nbsp;&nbsp;Select which Risk this action will be mitigating, or helping to mitigate.</label>
                        </Col>
                        <Col sm="12" style={{ marginTop: "10px", display: "none" }}>
                            <FormGroup>
                                <Select
                                    id="activityRiskId"
                                    name="activityRiskId"
                                    isDisabled={disableCustomRisk}
                                    closeMenuOnSelect={false}
                                    className="dropdown"
                                    placeholder="Select Activity Risk"
                                    value={activityRiskValue}
                                    options={activityRiskList}
                                    onChange={handleActivityRiskInputChange}
                                    isClearable hideSelectedOptions={false} isMulti
                                    components={{
                                        Option
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm="12" style={{ display: "none" }}>
                            <span style={{ fontSize: "110%" }} className="badge rounded-pill badge-success">2</span><label style={{ display: "contents" }} className="outlineLabel para-light-sm ">&nbsp;&nbsp;Select (if not already known) which Land Unit or Land Units this action will be performed across</label>
                        </Col>
                        <Col sm="12" style={{ marginTop: "10px", display: "none" }}>
                            <FormGroup>
                                <Select
                                    id="luId"
                                    name="luId"
                                    closeMenuOnSelect={false} isMulti
                                    className="dropdown"
                                    placeholder="Select LU"
                                    value={luValue}
                                    options={luList}
                                    onChange={handleLUInputChange}
                                    isClearable hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        {!editMode && <>
                                {(showRecommendedActionDropdown || showRecommendedActionText) &&
                                    <Col sm="12">
                                    <span style={{ fontSize: "110%" }} className="badge rounded-pill badge-success">1</span><label style={{ display: "contents" }} className="outlineLabel para-light-sm ">&nbsp;&nbsp;A number of risks have a series of "Possible Actions" listed below, which may be useful as a starting point. If the action you are considering is not listed, please select "Record a specific action" to create a custom action.</label>
                                    </Col>
                                }
                                <Col sm="12" style={{ marginTop: "10px" }}>
                                    {showRecommendedActionDropdown && <FormGroup>
                                        <Label>Possible Actions</Label>
                                        <Select
                                            id="recommendedActionId"
                                            name="recommendedActionId"
                                            isDisabled={disableRecommendedAction}
                                            closeMenuOnSelect={false}
                                            className="dropdown"
                                            placeholder="Select Possible Actions"
                                            value={recommendedActionValue}
                                            options={groupedOptions}
                                            onChange={handleRecommendedActionInputChange}
                                            isClearable hideSelectedOptions={false} isMulti
                                            components={{
                                                Option
                                            }}
                                            formatGroupLabel={formatGroupLabel}
                                        />
                                    </FormGroup>}
                                    {showRecommendedActionText && <FormGroup>
                                        <Label>Possible Action(Other)</Label>
                                        <textarea name="recommendedActionTextValue"
                                            value={recommendedActionTextValue}
                                            onChange={handleRecommendedActionTextChange}
                                            className="form-control"></textarea>
                                    </FormGroup>}
                                </Col>
                            </>
                        }
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button style={{ float: `right` }} onClick={handleActivityRiskSelect} color="primary" >{selectTitle}</Button>
                    <Button style={{ float: `right`, marginLeft: '10px' }} onClick={handleActivityRiskClose} color="primary" >Cancel</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={confirmRiskChangePopup.showConfirmRiskChangePopup}>
                <ModalHeader toggle={handleConfirmRiskChangePopupClose} >Confirm Risk change</ModalHeader>
                <ModalBody>
                    If you change the Risk this will clear the Action title and description - are you sure you wish to continue ?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleConfirmRiskChange}>Yes</Button>
                    <Button color="danger" onClick={handleConfirmRiskChangePopupClose}>No</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
export default ItemBasedActivityRisk